import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  privateMap.set(receiver, value);
  return value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver);
};

var _gql;

import { toNetwork } from '@aragon/connect-core';
import * as queries from './queries';
import GraphQLWrapper from './core/GraphQLWrapper';
import { parseApp, parseApps, parsePermissions, parseRepo, parseRoles } from './parsers';

function getOrgSubgraphUrl(network) {
  if (network.chainId === 1) {
    return 'https://api.thegraph.com/subgraphs/name/aragon/aragon-mainnet';
  }

  if (network.chainId === 4) {
    return 'https://api.thegraph.com/subgraphs/name/aragon/aragon-rinkeby';
  }

  if (network.chainId === 100) {
    return 'https://api.thegraph.com/subgraphs/name/1hive/aragon-xdai';
  }

  return null;
}

function appFiltersToQueryFilter(appFilters) {
  var queryFilter = {};

  if (appFilters.name) {
    queryFilter.repoName_in = appFilters.name.map(function (name) {
      return name.replace(/\.aragonpm\.eth$/, '');
    });
  }

  if (appFilters.address) {
    queryFilter.address_in = appFilters.address;
  }

  return queryFilter;
}

var ConnectorTheGraph =
/*#__PURE__*/
function () {
  function ConnectorTheGraph(config) {
    _classCallCheck(this, ConnectorTheGraph);

    _gql.set(this, void 0);

    this.name = 'thegraph';
    this.config = config;
    this.network = toNetwork(config.network);
    var orgSubgraphUrl = config.orgSubgraphUrl || getOrgSubgraphUrl(this.network);

    if (!orgSubgraphUrl) {
      throw new Error("The chainId ".concat(this.network.chainId, " is not supported by the TheGraph connector."));
    }

    __classPrivateFieldSet(this, _gql, new GraphQLWrapper(orgSubgraphUrl, {
      pollInterval: config.pollInterval,
      verbose: config.verbose
    }));
  }

  _createClass(ConnectorTheGraph, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(connection) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.connection = connection;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect(_x) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "disconnect",
    value: function () {
      var _disconnect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __classPrivateFieldGet(this, _gql).close();

                delete this.connection;

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function disconnect() {
        return _disconnect.apply(this, arguments);
      }

      return disconnect;
    }()
  }, {
    key: "rolesForAddress",
    value: function () {
      var _rolesForAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(organization, appAddress) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ROLE_BY_APP_ADDRESS('query'), {
                  appAddress: appAddress.toLowerCase()
                }, function (result) {
                  return parseRoles(result, organization);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function rolesForAddress(_x2, _x3) {
        return _rolesForAddress.apply(this, arguments);
      }

      return rolesForAddress;
    }()
  }, {
    key: "permissionsForOrg",
    value: function () {
      var _permissionsForOrg = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(organization) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ORGANIZATION_PERMISSIONS('query'), {
                  orgAddress: organization.address.toLowerCase()
                }, function (result) {
                  return parsePermissions(result, organization);
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function permissionsForOrg(_x4) {
        return _permissionsForOrg.apply(this, arguments);
      }

      return permissionsForOrg;
    }()
  }, {
    key: "onPermissionsForOrg",
    value: function onPermissionsForOrg(organization, callback) {
      return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ORGANIZATION_PERMISSIONS('subscription'), {
        orgAddress: organization.address.toLowerCase()
      }, callback, function (result) {
        return parsePermissions(result, organization);
      });
    }
  }, {
    key: "appByAddress",
    value: function () {
      var _appByAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(organization, appAddress) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.APP_BY_ADDRESS('query'), {
                  appAddress: appAddress.toLowerCase()
                }, function (result) {
                  return parseApp(result, organization);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function appByAddress(_x5, _x6) {
        return _appByAddress.apply(this, arguments);
      }

      return appByAddress;
    }()
  }, {
    key: "appForOrg",
    value: function () {
      var _appForOrg = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(organization, filters) {
        var apps;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ORGANIZATION_APPS('query'), {
                  appFilter: appFiltersToQueryFilter(filters),
                  first: 1,
                  orgAddress: organization.address.toLowerCase()
                }, function (result) {
                  return parseApps(result, organization);
                });

              case 2:
                apps = _context6.sent;
                return _context6.abrupt("return", apps[0]);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function appForOrg(_x7, _x8) {
        return _appForOrg.apply(this, arguments);
      }

      return appForOrg;
    }()
  }, {
    key: "appsForOrg",
    value: function () {
      var _appsForOrg = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(organization, filters) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.ORGANIZATION_APPS('query'), {
                  appFilter: appFiltersToQueryFilter(filters),
                  orgAddress: organization.address.toLowerCase()
                }, function (result) {
                  return parseApps(result, organization);
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function appsForOrg(_x9, _x10) {
        return _appsForOrg.apply(this, arguments);
      }

      return appsForOrg;
    }()
  }, {
    key: "onAppForOrg",
    value: function onAppForOrg(organization, filters, callback) {
      return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ORGANIZATION_APPS('subscription'), {
        appFilter: appFiltersToQueryFilter(filters),
        first: 1,
        orgAddress: organization.address.toLowerCase()
      }, function (apps) {
        return callback(apps[0]);
      }, function (result) {
        return parseApps(result, organization);
      });
    }
  }, {
    key: "onAppsForOrg",
    value: function onAppsForOrg(organization, filters, callback) {
      return __classPrivateFieldGet(this, _gql).subscribeToQueryWithParser(queries.ORGANIZATION_APPS('subscription'), {
        appFilter: appFiltersToQueryFilter(filters),
        orgAddress: organization.address.toLowerCase()
      }, callback, function (result) {
        return parseApps(result, organization);
      });
    }
  }, {
    key: "repoForApp",
    value: function () {
      var _repoForApp = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(organization, appAddress) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", __classPrivateFieldGet(this, _gql).performQueryWithParser(queries.REPO_BY_APP_ADDRESS('query'), {
                  appAddress: appAddress.toLowerCase()
                }, function (result) {
                  return parseRepo(result, organization);
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function repoForApp(_x11, _x12) {
        return _repoForApp.apply(this, arguments);
      }

      return repoForApp;
    }()
  }]);

  return ConnectorTheGraph;
}();

_gql = new WeakMap();
export default ConnectorTheGraph;